import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';
import commonStyles from '../../Common/commonStyles';
import ComponentCard from './ComponentCard';
const styles = StyleSheet.create({
    productsPageContainer: {
        marginHorizontal: commonStyles.marginHorizontal,
    },
    productsPageTitle: Object.assign(Object.assign({}, commonStyles.fontM), { fontWeight: 'bold' }),
});
function ProductsPage({ components, t, productLabels }) {
    return (React.createElement(View, { style: styles.productsPageContainer, break: true }, components.length > 0 ? (React.createElement(React.Fragment, null, components.map((component) => (React.createElement(ComponentCard, { key: component === null || component === void 0 ? void 0 : component.id, component: component, productLabels: productLabels }))))) : (React.createElement(Text, null, t('no_added_components')))));
}
export default withTranslation('specification')(ProductsPage);
